/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileName: NonNullable<unknown> }} Fileistoolargemaximumsizeis5mb8Inputs */

const en_fileistoolargemaximumsizeis5mb8 = /** @type {(inputs: Fileistoolargemaximumsizeis5mb8Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File ${i?.fileName} is too large. Maximum size is 5MB`)
};

const de_fileistoolargemaximumsizeis5mb8 = /** @type {(inputs: Fileistoolargemaximumsizeis5mb8Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Datei ${i?.fileName} ist zu groß. Die maximale Größe beträgt 5 MB.`)
};

/**
* | output |
* | --- |
* | "File {fileName} is too large. Maximum size is 5MB" |
*
* @param {Fileistoolargemaximumsizeis5mb8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const fileistoolargemaximumsizeis5mb8 = /** @type {((inputs: Fileistoolargemaximumsizeis5mb8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fileistoolargemaximumsizeis5mb8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fileistoolargemaximumsizeis5mb8(inputs)
	return de_fileistoolargemaximumsizeis5mb8(inputs)
});
export { fileistoolargemaximumsizeis5mb8 as "fileIsTooLargeMaximumSizeIs5MB" }